/* eslint-disable import/no-duplicates */

// lint-disable import/newline-after-import */
import { routingInstrumentation } from "@lib/sentry";
import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import colors from "@constants/color";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import { createDrawerNavigator } from "@react-navigation/drawer";
import { NavigationContainer } from "@react-navigation/native";
import {
  TransitionPresets,
  createStackNavigator,
} from "@react-navigation/stack";
import Home from "@screens/Home";
import React, { useEffect, useMemo, useRef } from "react";
import { Linking, Pressable, SafeAreaView, Text, View } from "react-native";
import BootSplash from "react-native-bootsplash";
import { useDispatch, useSelector } from "react-redux";
import { actions as authActions } from "@reducers/authReducer";
// auth
import EnterName from "@screens/Auth/EnterName";
import EnterOTP from "@screens/Auth/EnterOTP";
import EnterPhone from "@screens/Auth/EnterPhone";
import TLAddress from "@screens/Auth/TLAddress";
import TwoFactorAuth from "@screens/Auth/TwoFactorAuth";
import Walkthrough from "@screens/Auth/Walkthrough";

import BankDetails from "@screens/BankDetails";
import BankDetailsForm from "@screens/BankDetailsForm";
import CategoryNavigation from "@screens/CategoryNavigation";
import CustomerProfile from "@screens/CustomerProfile";
import OrderDetailsScreen from "@screens/OrderDetails";
import MarkAttendance from "@screens/Attendance/MarkAttendance";
import AttendanceDetail from "@screens/Attendance/AttendanceDetail";
import AttendanceHistory from "@screens/Attendance/AttendanceHistory";
import OrdersList from "@screens/OrdersList";
import OtherOrdersList from "@screens/OtherOrdersList";
import PassbookScreen from "@screens/Passbook";
import PlaceOrderView from "@screens/PlaceOrder/PlaceOrderView";
import ProfileProductRequests from "@screens/ProfileProductRequests";
import SearchScreen from "@screens/Search";
import AddProductRequestScreen from "@screens/Search/AddProductRequest";
import ProductRequestsScreen from "@screens/Search/ProductRequests";
import WalletDrawer from "@screens/Wallet/WalletDrawer";
import CustomerList from "@screens/YourStore/CustomerList";
import CustomerSegmentList from "@screens/YourStore/CustomerSegmentList";
// support
import { actions as navActions } from "@reducers/nav.reducer";
import CouponScreen from "@screens/CouponScreen";
import SupportTree from "@screens/SupportTree";
import SupportItem from "@screens/SupportTree/SupportItem";
import SupportTickets from "@screens/SupportTree/SupportTickets";
import SupportTicket from "@screens/SupportTree/SupportTickets/SupportTicket";

import RateOrderScreen from "@components/RateOrderScreen";
import CustomProductDetails from "@screens/CustomProductScreen";
import ProductDetails from "@screens/ProductScreen";

// cl flow
import CLFlow from "@screens/ClFlow";

// Leader training
import LeaderTraining from "@screens/LeaderTraining";
import TrainingVideoListing from "@screens/LeaderTraining/TrainingVideoListing";
import ReferEarn from "@screens/ReferEarn";
import ReferEarnStepsScreen from "@screens/ReferEarn/ReferEarnStepsScreen";
import ReferQRScreen from "@screens/ReferEarn/ReferQRScreen";
import ReferralList from "@screens/ReferralList";

import Story from "@screens/Story";

import KYCSetup from "@screens/KYCSetup";
import LeaderGrowthLadder from "@screens/LGL";
import LeaderLadderDetails from "@screens/LGL/LeaderLadderDetails";

import { setDeepLinkParams } from "@actions/deepLink.actions";
import urlParse from "url-parse";

// Delivery Page
import { store } from "@store";
// discarded cl

import PageNotFound from "@screens/PageNotFound";
import RejectScreen from "@screens/RejectedCl/";
import RaiseTicketScreen from "@screens/RejectedCl/RaiseTicket";

// privilege screens
import PrivilegeScreen from "@screens/RejectedCl/Privilege";

// Cl profile
import ProfileStack from "@screens/ProfileInfo";
import analytics from "@services/analytics";

import { NOTIFICATION_EVENTS } from "@constants/analyticsEventsCT";
import GullakMoney from "@screens/GullakMoney";
import LocationWithAddress from "@screens/Location";
import NotServicable from "@screens/LocationServiceablity/NotServiceable";
import LocationWithoutAddress from "@screens/LocationWithoutAddress";
import TimelineCrash from "@screens/TimelineCrash";
import VerifyAccountOtp from "@screens/VerifyAccount";
import AddNewUpi from "@screens/Wallet/AddNewUpi";
// import Wallet from "@screens/Wallet/Landing";
import Wallet from "@screens/Wallet/v2/index";
import AggTransactionsView from "@screens/Wallet/v2/AggTransactionsView";
import TransactionsView from "@screens/Wallet/v2/TransactionsView";
import ViewDispute from "@screens/Wallet/v2/ViewDispute";
import CreateDispute from "@screens/Wallet/v2/CreateDispute";
import WithdrawFromAcc from "@screens/WithdrawMoney/WithdrawFromAcc";
import FindUpi from "@screens/WithdrawGullakMoney/FindUpi";
import { verticalScale } from "@utils/scale";
import TodaysCustomers from "@screens/Shop/TodaysCustomers";
import RatingInfo from "@screens/RatingInfo";
import CustomerComplaint from "@screens/CustomerComplaint";

// Offer

// Vacation
import Vacation from "@screens/Vacation";
import VacationTnC from "@screens/Vacation/VacationTnC";

// Location
import LanguageSelection from "@screens/LanguageSelection";

// My Deliveries

import MyDeliveries from "@screens/MyDeliveries";
import MultiQuantityIssues from "@screens/CustomerOrderItems/MultiQuantityIssues";
import AllSamasya from "@screens/MyDeliveries/components/AllSamasya";
import CrateItemList from "@screens/MyDeliveries/ItemList";
import ComboItems from "@screens/MyDeliveries/components/ComboItems";
import DeliveryOrdersList from "@screens/MyDeliveries/DeliveryOrdersList";
import SkuOrdersDetails from "@screens/MyDeliveries/SkuOrdersDetails";
import DeliveryOrdersCrateList from "@screens/MyDeliveries/DeliveryOrdersCrateList";
import CrateHandoverVideos from "@screens/CrateHandoverVideos";
import DeliveryReturnsList from "@screens/MyDeliveries/DeliveryReturnsList";
import DailyOrderList from "@screens/MyDeliveries/components/DailyOrderList";
import ComboReturn from "@screens/MyDeliveries/components/ComboReturn";
import ReturnCompleteCrateOrder from "@screens/ReturnCompleteOrder/ReturnCompleteCrateOrder";
import PreDeliveryItemList from "@screens/CustomerOrderItems/PreDelivery";

// Self Deactivatoin
import SelfDeactivation from "@screens/SelfDeactivation";

// RRD
import DeliveryReturn from "@screens/RRD/DeliveryReturn";
import MyTask from "@screens/MyTasks";
import PerformanceMetrics from "@screens/PerformanceMetrics";
import CustomerOrdersView from "@screens/MyTasks/CustomerOrderView";
import OrdersMapView from "@screens/MyTasks/OrdersMapView";

import { BOTTOM_TAB_CLICKED } from "@constants/analyticsEvents";
import ShopPerformance from "@screens/ShopPerformance";
import VacationOrdersList from "@screens/Vacation/VacationOrdersList";

import AddBankDetails from "@screens/AddBankDetails";
import CategoryNavigationScreen from "@screens/CategoryNavigation";
import ClContest from "@screens/ClContest";
import ContestOverview from "@screens/ClContest/ContestOverview";
import MyCustomers from "@screens/ClContest/MyCustomers";
import OrderedList from "@screens/ClContest/MyCustomers/OrderedList";
import PastContest from "@screens/ClContest/PastContest";
import ClProfile from "@screens/ClProfile";
import AddCustomer from "@screens/Customer/AddCustomer";
import Customer from "@screens/Customer/Customer";
import UsersOrderList from "@screens/CustomerProfile/UsersOrderList";
import DailyGreetings from "@screens/DailyGreetings";
import DeliveryPage from "@screens/DeliveryPage";
import EnterAddress from "@screens/EarlyJourney/EnterAddress";
import EnterShopName from "@screens/EnterShopName";
// eslint-disable-next-line import/extensions
import FullPageVideoModal from "@screens/FullPageVideoModal/index.js";
import InviteFriends from "@screens/InviteFriends";
import OnBoardingQuestionaire from "@screens/OnBoardingQuestionaire";
import OrderSupport from "@screens/OrderDetails/OrderSupport";
import SelectProduct from "@screens/OrderDetails/SelectProduct";
import PlaceOrderSuccess from "@screens/PlaceOrderSuccess";
import PollForm from "@screens/PollForm";
import OTPVerification from "@screens/RRD/OTPVerification";
import NewOTPVerification from "@screens/MyTasks/OtpVerifcation/NewOTPVerification";
import RescheduleOTPVerification from "@screens/MyTasks/OtpVerifcation/RescheduleOTPVerification";
import WalletDynamicScreen from "@screens/Wallet/WalletDynamicScreen";
import WebViewPage from "@screens/WebViewPage";
import WithdrawMoney from "@screens/WithdrawMoney";
import WithDrawGullakMoney from "@screens/WithdrawGullakMoney";
import GullakAddFund from "@screens/WithdrawGullakMoney/AddFund";

import ReturnCompleteOrder from "@screens/ReturnCompleteOrder";
import VacationCalendar from "@screens/Vacation/VacationCalendar";
import LoggedInDevices from "@screens/Logout";

import DeliveryReturnOverview from "@screens/MyDeliveries/Overview";
import OverviewDetail from "@screens/MyDeliveries/Overview/OverviewDetail";

import SortingDeliveries from "@screens/MyDeliveries/SortingDeliveries";
import CrateCustomerList from "@screens/MyDeliveries/SortingDeliveries/CrateCustomerList";
import CrateScanner from "@screens/MyDeliveries/SortingDeliveries/CrateScanner";
import SortingItemList from "@screens/CustomerOrderItems/Sorting";

// Dark Store — CMO executive "Receiving & Racks" (Lane A)
// Multi-EDD racking hub: the home widget's `nav_to` "ReceivingTpList" opens
// the hub (Today / Advance / Pending); each bucket opens ReceivingBucketList.
import ReceivingHub from "@screens/Receiving/ReceivingHub";
import ReceivingBucketList from "@screens/Receiving/ReceivingBucketList";
import ReceivingScanRack from "@screens/Receiving/ReceivingScanRack";
import ReceivingScanShipments from "@screens/Receiving/ReceivingScanShipments";
// Dark Store — CP routing (Routing menu → "Dark Store Routing")
import DsRoutingHub from "@screens/DsRouting/DsRoutingHub";
import DsRoutingTpList from "@screens/DsRouting/DsRoutingTpList";
import DsRoutingRecommended from "@screens/DsRouting/DsRoutingRecommended";
import DsReturnsList from "@screens/DsRouting/DsReturnsList";
import DsRoutingDbList from "@screens/DsRouting/DsRoutingDbList";
import DsRoutingDbTps from "@screens/DsRouting/DsRoutingDbTps";

import CpDeliveryBoys from "@screens/CpDeliveryBoys";
import CreateDbOrList from "@screens/CpDeliveryBoys/CreateDbOrList";
import CpDeliveryRoutes from "@screens/CpDeliveryRoutes";

import AddDeliveryRoute from "@screens/CpDeliveryRoutes/AddDeliveryRoute";

import DeliveryRouteList from "@screens/CpDeliveryRoutes/DeliveryRouteList";
import PartnerRoutingAndPacking from "@screens/PartnerRoutingAndPacking";
import CpRoutingScreen from "@screens/PartnerRoutingAndPacking/screens/CpRoutingScreen";
import PackingDbListScreen from "@screens/PartnerRoutingAndPacking/screens/PackingDbListScreen";
import PackingInterfaceScreen from "@screens/PartnerRoutingAndPacking/screens/PackingInterfaceScreen";
import LedgerTxns from "@screens/LedgerTxns";

// Home Widgets
import DBManagement from "@screens/DbManagement";
import LiveDbLocations from "@screens/LiveDbLocations";
import LiveDbTrail from "@screens/LiveDbTrail";
import OutForDelivery from "@screens/OutForDelivery";
import OutForDeliveryDetails from "@screens/OutForDeliveryDetails";
import Routing from "@screens/Routing";
import Recon from "@screens/Recon";
import ReconHistory from "@screens/Recon/ReconHistory";
import ReconDetails from "@screens/ReconDetails";
import ReconHistoryDetails from "@screens/ReconDetails/ReconHistoryDetails";
import DeliveryPerformance from "@screens/DeliveryPerformance";
import ReturnDetail from "@screens/ReturnDetail";

import CpOnlinePayment from "@screens/CpOnlinePayment/index";
import CpOnlinePaymentV2 from "@screens/CpOnlinePaymentV2/index";

import ReturnItemDetails from "@screens/Returns/ReturnItemDetails";
import ReturnCrateDetails from "@screens/Returns/ReturnCrateDetails";
import MovexGeo from "@movexgeo/react-native-movex";
import { check, request, PERMISSIONS, RESULTS } from "react-native-permissions";
import DynamicCMSListing from "../components/CMS/DynamicCMSListing";
import AuthLoadingScreen from "./AuthLoading";
import getNavConfig from "./getNavConfig";
import Returns from "../screens/Returns";
import CPCXQRPayment from "../screens/CpCxQrPayment";

const Stack = createStackNavigator();
const Drawer = createDrawerNavigator();
const Tab = createBottomTabNavigator();

// eslint-disable-next-line import/no-named-as-default-member
export const navigationRef = React.createRef();
// eslint-disable-next-line import/no-named-as-default-member
export const routeNameRef = React.createRef();
// eslint-disable-next-line import/no-named-as-default-member
export const previousScreens = React.createRef([]);

// const updateCurrentAppScreen = (state) => {
//   try {
//     const { routes = [] } = state.routes[0].state;
//     if (routes.length !== 0) {
//       const { name = "" } = routes[routes.length - 1];
//       previousScreens.current = previousScreens.current
//         ? [...previousScreens.current, name]
//         : [name];
//     }
//   } catch (error) {
//     console.log("updateCurrentAppScreen_err", error);
//   }
// };

export function dispatch(cb) {
  navigationRef.current?.dispatch(cb);
}

export function navigate(name, params, key) {
  if (navigationRef.current) {
    navigationRef.current.navigate(name, params, key);
  } else {
    // eslint-disable-next-line no-console
    console.log("navigationRef.current is null");
  }
}
function getHeader(
  routeName,
  navigation,
  navRoute,
  RightButton,
  IsRightIconDropDown,
) {
  const { params } = navRoute;
  const navConfig = getNavConfig();
  const headerName = navRoute.params
    ? navigation && navRoute.params.headerName
    : "";
  const route = navConfig[routeName] || undefined;
  if (!route) {
    return <></>;
  }
  if (route && !route.header) {
    return <></>;
  }
  if (route) {
    return (
      <HeaderWithBackAndTitle
        headertitle={
          (route.title && route.title) || (params && params.headerTitle) || ""
        }
        headerStyle={route?.headerStyle || params?.headerStyle}
        route={navRoute}
        headerColor={route.headerColor || "#fff"}
        hideShadow={route.hideShadow || false}
        navigation={navigation}
        isTransparent={route.isTransparent}
        headerStaticName={headerName}
        leftIcon={route.leftIcon}
        onCloseNavigateTo={route.onCloseNavigateTo}
        dynamicTitleRead={route.dynamicTitleRead}
        rightIconClickRedirect={route.rightIconClickRedirect}
        rightIcon={route.rightIcon}
        shouldEmitEvent={route.shouldEmitEvent}
        RightButton={RightButton}
        IsRightIconDropDown={IsRightIconDropDown}
        {...route}
        numberOfLines={route?.numberOfLines || params?.numberOfLines || 0}
      />
    );
  }
}

const commonHeaderConfig = ({ route, navigation }) => ({
  backBehavior: "history",
  keyboardHidesTabBar: true,
  header: ({ options }) => {
    const RightButton = options && options.headerRight;
    const IsRightIconDropDown = options && options.IsRightIconDropDown;
    const numberOfLines = options?.numberOfLines || 0;
    return (
      <View>
        <SafeAreaView />
        <View>
          {getHeader(
            route.name,
            navigation,
            route,
            RightButton,
            IsRightIconDropDown,
            numberOfLines,
          )}
        </View>
      </View>
    );
  },
});

const AuthScreens = [
  {
    name: "EnterPhone",
    Component: EnterPhone,
  },
  {
    name: "EnterOTP",
    Component: EnterOTP,
  },
  {
    name: "TLAddress",
    Component: TLAddress,
  },
  {
    name: "Walkthrough",
    Component: Walkthrough,
  },
  {
    name: "TwoFactorAuth",
    Component: TwoFactorAuth,
  },
];

function WalletDrawerNavigator() {
  return (
    <Stack.Navigator
      initialRouteName="Gullak"
      screenOptions={{
        headerShown: false,
      }}
    >
      {[
        {
          name: "Gullak",
          screen: Wallet,
        },

        {
          name: "ProfileProductRequests",
          screen: ProfileProductRequests,
        },
        {
          name: "BankDetails",
          screen: BankDetails,
        },
      ].map(({ name, screen }) => {
        return (
          <Stack.Screen
            options={{ ...TransitionPresets.SlideFromRightIOS }}
            key={name}
            name={name}
            component={screen}
          />
        );
      })}
    </Stack.Navigator>
  );
}

function BottomTabIcon({ route, focused }) {
  const navConfig = getNavConfig();

  // eslint-disable-next-line react/no-unstable-nested-components
  function IconComponent() {
    return <></>;
  }
  let Label = "";
  if (navConfig[route.name]) {
    // eslint-disable-next-line no-func-assign
    IconComponent = navConfig[route.name].bottomTabIcon;
    Label = navConfig[route.name].label;
  }

  return (
    <View
      // eslint-disable-next-line react-native/no-inline-styles
      style={{
        flex: 1,
      }}
    >
      <View
        // eslint-disable-next-line react-native/no-inline-styles
        style={{
          height: verticalScale(25),
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <IconComponent active={focused || false} />
      </View>

      {typeof Label === "function" ? (
        <Label
          // eslint-disable-next-line react-native/no-inline-styles
          style={{
            fontFamily: focused
              ? "NotoSansDevanagari-Bold"
              : "NotoSansDevanagari-Regular",
            textAlign: "center",
            fontSize: 12,
            fontWeight: "normal",
            paddingTop: 2,
          }}
        />
      ) : (
        <Text
          // eslint-disable-next-line react-native/no-inline-styles
          style={{
            fontFamily: focused
              ? "NotoSansDevanagari-Bold"
              : "NotoSansDevanagari-Regular",
            textAlign: "center",
            fontSize: 12,
            fontWeight: "normal",
            paddingTop: 2,
            width: "100%",
          }}
        >
          {Label}
        </Text>
      )}
    </View>
  );
}

const BottomTabButton = (routeName, _checkNewPosts) =>
  function ({ onPress, children, _loading }) {
    const onPressWithAnalytics = () => {
      analytics.trackEvent(BOTTOM_TAB_CLICKED, {
        screen: routeName,
      });
      onPress();
      // checkNewPosts();
    };

    return (
      <Pressable
        testID={routeName}
        android_ripple={{ color: "rgba(0,0,0,0.08)", borderless: true }}
        // eslint-disable-next-line react-native/no-inline-styles
        style={{
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          paddingBottom: 4,
        }}
        onPress={onPressWithAnalytics}
      >
        {children}
      </Pressable>
    );
  };

function Null() {
  return null;
}
function MainTabsScreens() {
  const cp_db_id = useSelector(({ auth }) => auth?.user?.cp_db_id);

  const screens = useMemo(
    () =>
      cp_db_id
        ? [
            {
              name: "Home",
              screen: Home,
              navigationOptions: {
                tabBarLabel: "Offers",
              },
            },
            {
              name: "MyDeliveries",
              screen: MyDeliveries,
              navigationOptions: {
                tabBarLabel: "My Delivery",
              },
            },
          ]
        : [
            {
              name: "Home",
              screen: Home,
              navigationOptions: {
                tabBarLabel: "Offers",
              },
            },

            {
              name: "MyDeliveries",
              screen: MyDeliveries,
              navigationOptions: {
                tabBarLabel: "My Delivery",
              },
            },
            /* disabled Customers tab
            {
              name: "Customers",
              screen: CustomerList,
              navigationOptions: {
                tabBarLabel: "Gullak",
              },              
            },
            */
          ],

    [cp_db_id],
  );
  return (
    <Tab.Navigator
      screenOptions={({ route, navigation }) => ({
        // tabBarLabel: Null,
        lazy: true,
        tabBarActiveTintColor: colors.black,
        tabBarInactiveTintColor: colors.lightBlack,
        tabBarStyle: {
          display: "flex",
          height: 65,
          paddingBottom: 4,
        },
        headerShown: false,
        // eslint-disable-next-line react/no-unstable-nested-components
        tabBarIcon: (props) => (
          <BottomTabIcon navigation={navigation} route={route} {...props} />
        ),
        tabBarButton: BottomTabButton(route.name),
        tabBarLabel: Null,
      })}
    >
      {screens.map(({ name, screen }) => {
        return <Tab.Screen key={name} name={name} component={screen} />;
      })}
    </Tab.Navigator>
  );
}

const WrapperForStack = [
  {
    name: "MarkAttendance",
    screen: MarkAttendance,
  },
  {
    name: "AttendanceDetail",
    screen: AttendanceDetail,
  },
  {
    name: "AttendanceHistory",
    screen: AttendanceHistory,
  },
  {
    name: "RaiseTicket",
    screen: RaiseTicketScreen,
  },
  {
    name: "CategoryNavigationScreen",
    screen: CategoryNavigationScreen,
  },
  {
    name: "RateOrder",
    screen: RateOrderScreen,
  },
  {
    name: "Customer",
    screen: Customer,
  },
  {
    name: "AddCustomer",
    screen: AddCustomer,
  },
  {
    name: "OrderDetails",
    screen: OrderDetailsScreen,
  },
  {
    name: "DailyGreetings",
    screen: DailyGreetings,
  },
  {
    name: "Search",
    screen: SearchScreen,
  },
  {
    name: "PlaceOrderSuccess",
    screen: PlaceOrderSuccess,
  },
  {
    name: "ConfirmOrder",
    screen: PlaceOrderView,
  },
  {
    name: "AddProductRequest",
    screen: AddProductRequestScreen,
  },
  {
    name: "ProductRequests",
    screen: ProductRequestsScreen,
  },
  {
    name: "ProfileInfo",
    screen: ProfileStack,
  },
  {
    name: "CustomerSegmentList",
    screen: CustomerSegmentList,
  },
  {
    name: "CustomerProfile",
    screen: CustomerProfile,
  },
  {
    name: "UsersOrderList",
    screen: UsersOrderList,
  },
  {
    name: "NotServicable",
    screen: NotServicable,
  },
  {
    name: "BankDetailsForm",
    screen: BankDetailsForm,
  },
  {
    name: "SupportTree",
    screen: SupportTree,
  },
  {
    name: "SupportTickets",
    screen: SupportTickets,
  },
  {
    name: "SupportTicket",
    screen: SupportTicket,
  },
  {
    name: "CouponScreen",
    screen: CouponScreen,
  },
  {
    name: "LeaderTraining",
    screen: LeaderTraining,
  },
  {
    name: "TrainingVideoListing",
    screen: TrainingVideoListing,
  },
  {
    name: "SupportItem",
    screen: SupportItem,
  },
  {
    name: "ProductDetails",
    screen: ProductDetails,
  },
  {
    name: "CustomProductDetails",
    screen: CustomProductDetails,
  },
  {
    name: "Passbook",
    screen: PassbookScreen,
  },
  {
    name: "ReferEarnScreen",
    screen: ReferEarn,
  },
  {
    name: "ReferEarnStepsScreen",
    screen: ReferEarnStepsScreen,
  },
  {
    name: "ReferQRScreen",
    screen: ReferQRScreen,
  },
  {
    name: "ReferralList",
    screen: ReferralList,
  },
  {
    name: "WithdrawMoney",
    screen: WithdrawMoney,
  },
  {
    name: "WithDrawGullakMoney",
    screen: WithDrawGullakMoney,
  },
  {
    name: "GullakAddFund",
    screen: GullakAddFund,
  },
  {
    name: "WithdrawFromAcc",
    screen: WithdrawFromAcc,
  },
  {
    name: "FindUpi",
    screen: FindUpi,
  },
  {
    name: "AddBankDetails",
    screen: AddBankDetails,
  },
  {
    name: "AddNewUpi",
    screen: AddNewUpi,
  },
  {
    name: "WalletDynamicScreen",
    screen: WalletDynamicScreen,
  },
  {
    name: "AggTransactionsView",
    screen: AggTransactionsView,
  },
  {
    name: "TransactionsView",
    screen: TransactionsView,
  },
  {
    name: "ViewDispute",
    screen: ViewDispute,
  },
  {
    name: "CreateDispute",
    screen: CreateDispute,
  },
  {
    name: "DynamicCMSListing",
    screen: DynamicCMSListing,
  },
  {
    name: "TLAddress",
    screen: TLAddress,
  },
  {
    name: "DeliveryPage",
    screen: DeliveryPage,
  },
  {
    name: "WebView",
    screen: WebViewPage,
  },
  {
    name: "PollForm",
    screen: PollForm,
  },
  {
    name: "PageNotFound",
    screen: PageNotFound,
  },
  {
    name: "TimelineCrash",
    screen: TimelineCrash,
  },
  {
    name: "SelectProduct",
    screen: SelectProduct,
  },
  {
    name: "ReturnCompleteOrder",
    screen: ReturnCompleteOrder,
  },
  {
    name: "OrderSupport",
    screen: OrderSupport,
  },
  {
    name: "Story",
    screen: Story,
  },
  {
    name: "KYCSetup",
    screen: KYCSetup,
  },
  {
    name: "LeaderGrowthLadder",
    screen: LeaderGrowthLadder,
  },
  {
    name: "LeaderLadderDetails",
    screen: LeaderLadderDetails,
  },
  {
    name: "Location",
    screen: LocationWithoutAddress,
  },
  {
    name: "LocationViaAddress",
    screen: LocationWithAddress,
  },
  {
    name: "ClProfile",
    screen: ClProfile,
  },
  {
    name: "GullakMoney",
    screen: GullakMoney,
  },
  {
    name: "VerifyAccount",
    screen: VerifyAccountOtp,
  },
  {
    name: "LanguageSelection",
    screen: LanguageSelection,
  },
  {
    name: "SelfDeactivation",
    screen: SelfDeactivation,
  },
  {
    name: "Vacation",
    screen: Vacation,
  },
  {
    name: "VacationCalendar",
    screen: VacationCalendar,
  },
  {
    name: "VacationTnC",
    screen: VacationTnC,
  },
  {
    name: "TodaysCustomers",
    screen: TodaysCustomers,
  },
  {
    name: "OrdersList",
    screen: OrdersList,
  },
  {
    name: "OtherOrdersList",
    screen: OtherOrdersList,
  },
  {
    name: "CategoryNavigation",
    screen: CategoryNavigation,
  },
  {
    name: "ShopPerformance",
    screen: ShopPerformance,
  },
  {
    name: "MyDeliveries",
    screen: MyDeliveries,
  },
  {
    name: "Customers",
    screen: CustomerList,
  },
  {
    name: "MultiQuantityIssues",
    screen: MultiQuantityIssues,
  },
  {
    name: "AllSamasya",
    screen: AllSamasya,
  },
  {
    name: "CrateItemList",
    screen: CrateItemList,
  },
  {
    name: "PreDeliveryItemList",
    screen: PreDeliveryItemList,
  },
  {
    name: "ComboItems",
    screen: ComboItems,
  },
  {
    name: "DeliveryOrdersList",
    screen: DeliveryOrdersList,
  },
  {
    name: "SkuOrdersDetails",
    screen: SkuOrdersDetails,
  },
  {
    name: "DeliveryOrdersCrateList",
    screen: DeliveryOrdersCrateList,
  },
  {
    name: "CrateHandoverVideos",
    screen: CrateHandoverVideos,
  },
  {
    name: "DeliveryReturnsList",
    screen: DeliveryReturnsList,
  },
  {
    name: "DailyOrderList",
    screen: DailyOrderList,
  },
  {
    name: "ComboReturn",
    screen: ComboReturn,
  },
  {
    name: "ReturnCompleteCrateOrder",
    screen: ReturnCompleteCrateOrder,
  },
  {
    name: "Gullak",
    screen: WalletDrawerNavigator,
  },
  {
    name: "VacationOrdersList",
    screen: VacationOrdersList,
  },
  {
    name: "InviteFriends",
    screen: InviteFriends,
  },
  {
    name: "ClContest",
    screen: ClContest,
  },
  {
    name: "PastContest",
    screen: PastContest,
  },
  {
    name: "ContestOverview",
    screen: ContestOverview,
  },
  {
    name: "OrderedList",
    screen: OrderedList,
  },
  {
    name: "MyCustomers",
    screen: MyCustomers,
  },
  {
    name: "FullPageVideoModal",
    screen: FullPageVideoModal,
  },
  {
    name: "OnBoardingQuestionaire",
    screen: OnBoardingQuestionaire,
  },
  {
    name: "DeliveryReturn",
    screen: DeliveryReturn,
  },
  {
    name: "MyTask",
    screen: MyTask,
  },
  {
    name: "CustomerOrdersView",
    screen: CustomerOrdersView,
  },
  {
    name: "OrdersMapView",
    screen: OrdersMapView,
  },
  {
    name: "PerformanceMetrics",
    screen: PerformanceMetrics,
  },
  {
    name: "OTPVerification",
    screen: OTPVerification,
  },
  {
    name: "NewOTPVerification",
    screen: NewOTPVerification,
  },
  {
    name: "RescheduleOTPVerification",
    screen: RescheduleOTPVerification,
  },
  {
    name: "LoggedInDevices",
    screen: LoggedInDevices,
  },
  {
    name: "RatingInfo",
    screen: RatingInfo,
  },
  {
    name: "CustomerComplaint",
    screen: CustomerComplaint,
  },
  {
    name: "DeliveryReturnOverview",
    screen: DeliveryReturnOverview,
  },
  {
    name: "OverviewDetail",
    screen: OverviewDetail,
  },
  {
    name: "SortingDeliveries",
    screen: SortingDeliveries,
  },
  {
    name: "CrateCustomerList",
    screen: CrateCustomerList,
  },
  {
    name: "CrateScanner",
    screen: CrateScanner,
  },
  {
    name: "SortingItemList",
    screen: SortingItemList,
  },
  {
    name: "ReceivingTpList",
    screen: ReceivingHub,
  },
  {
    name: "ReceivingBucketList",
    screen: ReceivingBucketList,
  },
  {
    name: "ReceivingScanRack",
    screen: ReceivingScanRack,
  },
  {
    name: "ReceivingScanShipments",
    screen: ReceivingScanShipments,
  },
  {
    name: "DsRoutingHub",
    screen: DsRoutingHub,
  },
  {
    name: "DsRoutingTpList",
    screen: DsRoutingTpList,
  },
  {
    name: "DsRoutingRecommended",
    screen: DsRoutingRecommended,
  },
  {
    name: "DsReturnsList",
    screen: DsReturnsList,
  },
  {
    name: "DsRoutingDbList",
    screen: DsRoutingDbList,
  },
  {
    name: "DsRoutingDbTps",
    screen: DsRoutingDbTps,
  },
  {
    name: "CpDeliveryBoys",
    screen: CpDeliveryBoys,
  },
  {
    name: "CreateDbOrList",
    screen: CreateDbOrList,
  },
  {
    name: "CpDeliveryRoutes",
    screen: CpDeliveryRoutes,
  },
  {
    name: "AddDeliveryRoute",
    screen: AddDeliveryRoute,
  },
  {
    name: "DeliveryRouteList",
    screen: DeliveryRouteList,
  },
  {
    name: "PartnerRoutingAndPacking",
    screen: PartnerRoutingAndPacking,
  },
  {
    name: "CpRoutingScreen",
    screen: CpRoutingScreen,
  },
  {
    name: "PackingDbListScreen",
    screen: PackingDbListScreen,
  },
  {
    name: "PackingInterfaceScreen",
    screen: PackingInterfaceScreen,
  },
  {
    name: "LedgerTxns",
    screen: LedgerTxns,
  },
  {
    name: "DBManagement",
    screen: DBManagement,
  },
  {
    name: "LiveDbLocations",
    screen: LiveDbLocations,
  },
  {
    name: "LiveDbTrail",
    screen: LiveDbTrail,
  },
  {
    name: "OutForDelivery",
    screen: OutForDelivery,
  },
  {
    name: "OutForDeliveryDetails",
    screen: OutForDeliveryDetails,
  },
  {
    name: "Routing",
    screen: Routing,
  },
  {
    name: "Recon",
    screen: Recon,
  },
  {
    name: "ReconHistory",
    screen: ReconHistory,
  },
  {
    name: "ReconDetails",
    screen: ReconDetails,
  },
  {
    name: "ReconHistoryDetails",
    screen: ReconHistoryDetails,
  },
  {
    name: "CpOnlinePayment",
    screen: CpOnlinePayment,
  },
  {
    name: "CpOnlinePaymentV2",
    screen: CpOnlinePaymentV2,
  },
  {
    name: "DeliveryPerformance",
    screen: DeliveryPerformance,
  },
  {
    name: "Returns",
    screen: Returns,
  },
  {
    name: "ReturnItemDetails",
    screen: ReturnItemDetails,
  },
  {
    name: "ReturnCrateDetails",
    screen: ReturnCrateDetails,
  },
  { name: "CPCXQRPayment", screen: CPCXQRPayment },
  {
    name: "ReturnDetail",
    screen: ReturnDetail,
  },
];

function AuthStackScreen() {
  return (
    <Stack.Navigator screenOptions={commonHeaderConfig}>
      {AuthScreens.map(({ name, Component }) => (
        <Stack.Screen
          options={{ ...TransitionPresets.SlideFromRightIOS }}
          key={name}
          name={name}
          component={Component}
        />
      ))}
    </Stack.Navigator>
  );
}

const NameStackScreens = [
  {
    name: "EnterName",
    screen: EnterName,
  },
  {
    name: "Walkthrough",
    screen: Walkthrough,
  },
];

function NameStackScreen() {
  return (
    <Stack.Navigator screenOptions={commonHeaderConfig}>
      {NameStackScreens.map(({ name, screen }) => (
        <Stack.Screen
          options={{ ...TransitionPresets.SlideFromRightIOS }}
          key={name}
          name={name}
          component={screen}
        />
      ))}
    </Stack.Navigator>
  );
}

function HomeScreenStack() {
  const dispatchRedux = useDispatch();

  const locationPending = useRef(false);

  const pollLocation = async () => {
    if (locationPending.current) return;
    locationPending.current = true;
    try {
      const fix = await MovexGeo.captureCurrentPosition({
        enable_high_accuracy: true,
        timeout_ms: 15000,
      });
      dispatchRedux(
        authActions.updateLiveLocation({
          latitude: fix.lat,
          longitude: fix.lng,
        }),
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("LIVE_LOCATION_ERROR:", error);
    } finally {
      locationPending.current = false;
    }
  };

  const checkPermission = async () => {
    try {
      const result = await check(PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION);
      if (result === RESULTS.GRANTED) {
        pollLocation();
        return true;
      } else if (result === RESULTS.DENIED) {
        const requestResult = await request(
          PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION,
        );
        if (requestResult === RESULTS.GRANTED) {
          pollLocation();
          return true;
        }
      }
    } catch (error) {
      console.error("Permission check error:", error);
    }
    return false;
  };

  useEffect(() => {
    let intervalId;
    let mounted = true;
    checkPermission().then((granted) => {
      if (granted && mounted) {
        intervalId = setInterval(pollLocation, 10000);
      }
    });
    return () => {
      mounted = false;
      clearInterval(intervalId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Stack.Navigator
      initialRouteName="Bottoms"
      screenOptions={commonHeaderConfig}
    >
      <Stack.Screen name="Bottoms" component={HomeScreenDrawer} />
      {WrapperForStack.map(({ name, screen }) => {
        if (name === "Story") {
          return (
            <Stack.Screen
              options={{ ...TransitionPresets.ModalSlideFromBottomIOS }}
              key={name}
              name={name}
              component={screen}
            />
          );
        } else {
          return (
            <Stack.Screen
              options={{ ...TransitionPresets.SlideFromRightIOS }}
              key={name}
              name={name}
              component={screen}
            />
          );
        }
      })}
    </Stack.Navigator>
  );
}

function HomeScreenDrawer() {
  return (
    <Drawer.Navigator
      initialRouteName="home"
      screenOptions={{ headerShown: false }}
      // eslint-disable-next-line react/no-unstable-nested-components
      drawerContent={(props) => <WalletDrawer {...props} />}
      useLegacyImplementation={false}
    >
      <Drawer.Screen name="home" component={MainTabsScreens} />
    </Drawer.Navigator>
  );
}

const DiscardedStack = [
  {
    name: "Reject",
    Component: RejectScreen,
  },
  {
    name: "RaiseTicket",
    Component: RaiseTicketScreen,
  },
];

function DiscardedStackScreen() {
  return (
    <Stack.Navigator screenOptions={commonHeaderConfig}>
      {DiscardedStack.map(({ name, Component }) => (
        <Stack.Screen
          options={{ ...TransitionPresets.SlideFromRightIOS }}
          key={name}
          name={name}
          component={Component}
        />
      ))}
    </Stack.Navigator>
  );
}

const PrivilegeStack = [
  {
    name: "PrivilegeScreen",
    Component: PrivilegeScreen,
  },
];

function PrivilegeStackScreen() {
  return (
    <Stack.Navigator screenOptions={commonHeaderConfig}>
      {PrivilegeStack.map(({ name, Component }) => (
        <Stack.Screen
          options={{ ...TransitionPresets.SlideFromRightIOS }}
          key={name}
          name={name}
          component={Component}
        />
      ))}
    </Stack.Navigator>
  );
}

const DeactivatedStack = [
  {
    name: "SelfDeactivation",
    Component: SelfDeactivation,
  },
];

function DeactivatedStackScreen() {
  return (
    <Stack.Navigator screenOptions={commonHeaderConfig}>
      {DeactivatedStack.map(({ name, Component }) => (
        <Stack.Screen
          options={{ ...TransitionPresets.SlideFromRightIOS }}
          key={name}
          name={name}
          component={Component}
        />
      ))}
    </Stack.Navigator>
  );
}

const noServiceScreens = [
  {
    name: "LocationViaAddress",
    Component: LocationWithAddress,
  },
  {
    name: "NotServicable",
    Component: NotServicable,
  },
  {
    name: "Location",
    Component: LocationWithoutAddress,
  },
  {
    name: "TLAddress",
    Component: TLAddress,
  },
];

function NoServiceStack() {
  return (
    <Stack.Navigator
      screenOptions={commonHeaderConfig}
      initialRouteName="NotServicable"
    >
      {noServiceScreens.map(({ name, Component }) => (
        <Stack.Screen
          options={{ ...TransitionPresets.SlideFromRightIOS }}
          key={name}
          name={name}
          component={Component}
        />
      ))}
    </Stack.Navigator>
  );
}

const LocationScreens = [
  {
    name: "Location",
    Component: LocationWithoutAddress,
  },
  {
    name: "LocationViaAddress",
    Component: LocationWithAddress,
  },
  {
    name: "NotServicable",
    Component: NotServicable,
  },
  {
    name: "TLAddress",
    Component: TLAddress,
  },
];

const SignupAddressScreens = [
  {
    name: "LocationViaAddress",
    Component: LocationWithAddress,
  },
  {
    name: "TLAddress",
    Component: TLAddress,
  },
  {
    name: "Location",
    Component: LocationWithoutAddress,
  },
];

function LocationStack() {
  return (
    <Stack.Navigator screenOptions={commonHeaderConfig}>
      {LocationScreens.map(({ name, Component }) => (
        <Stack.Screen
          options={{ ...TransitionPresets.SlideFromRightIOS }}
          key={name}
          name={name}
          component={Component}
        />
      ))}
    </Stack.Navigator>
  );
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function SignupAddressStack() {
  return (
    <Stack.Navigator screenOptions={commonHeaderConfig}>
      {SignupAddressScreens.map(({ name, Component }) => (
        <Stack.Screen key={name} name={name} component={Component} />
      ))}
    </Stack.Navigator>
  );
}

const EarlyJourneyScreens = [
  {
    name: "FullPageVideoModal",
    Component: FullPageVideoModal,
  },
  {
    name: "OnBoardingQuestionaire",
    Component: OnBoardingQuestionaire,
  },
  {
    name: "EnterShopName",
    Component: EnterShopName,
  },
  {
    name: "EnterAddress",
    Component: EnterAddress,
  },
  {
    name: "LocationViaAddress",
    Component: LocationWithAddress,
  },
  {
    name: "NotServicable",
    Component: NotServicable,
  },
  {
    name: "InviteFriends",
    Component: InviteFriends,
  },
];

function EarlyJourneyStack() {
  const earlyJourney = useSelector((state) => state.auth?.user?.earlyJourney);
  const {
    questionAnswered = 0,
    showCms1 = false,
    showAddressScreen = false,
    showCms2 = false,
  } = earlyJourney || {};
  let sliceIndex = 0;
  // Skipping stack screen based on Early Journey Progress
  if (questionAnswered === 0) sliceIndex = 0;
  else if (
    questionAnswered > 0 &&
    !showCms1 &&
    !showAddressScreen &&
    !showCms2
  ) {
    sliceIndex = 1;
  } else if (showCms1) sliceIndex = 2;
  else if (showAddressScreen) sliceIndex = 3;
  else sliceIndex = 6;

  return (
    <Stack.Navigator screenOptions={commonHeaderConfig}>
      {EarlyJourneyScreens.map(({ name, Component }) => (
        <Stack.Screen key={name} name={name} component={Component} />
      )).slice(sliceIndex)}
    </Stack.Navigator>
  );
}

const getActiveRouteName = (state) => {
  const route = state && state.routes[state.index ? state.index : 0];

  if (route && route.state) {
    // Dive into nested navigators
    return getActiveRouteName(route.state);
  }

  return route.name;
};

export const NATIVE_PREFIX = "citymall-leader://";
export const APPLINK_URI_SCHEME = "cl-app://";
export const LEGACY_BRANCH_PREFIX = "https://unwtb.app.link/";
export const APPLINK_PREFIX = "https://cl.ctml.in/";

const screen_config = {
  Home: {
    parent: "cm/main/home",
    params: ["pnData"],
  },
  Training: {
    parent: "cm/main/home",
  },
  Orders: {
    parent: "cm/main/home",
  },
  Customers: {
    parent: "cm/main/home",
  },
  Gullak: {
    parent: "cm/main/home",
  },
  OrderDetails: {
    parent: "cm",
    params: ["order_id"],
  },
  ProductDetails: {
    parent: "cm",
    params: ["slug"],
  },
  DynamicCMSListing: {
    parent: "cm",
    params: ["entityId"],
  },
  DailyGreetings: {
    parent: "cm",
    params: ["entityId"],
  },
  CategoryNavigationScreen: {
    parent: "cm",
    params: ["selectedCat", "selectedSubCat"],
  },
  LanguageSelection: { parent: "cm" },
  Vacation: { parent: "cm" },
  VacationCalendar: { parent: "cm" },
  VacationTnC: { parent: "cm" },
  VacationOrdersList: { parent: "cm" },
  RateOrder: { parent: "cm" },
  Customer: { parent: "cm" },
  AddCustomer: { parent: "cm" },
  Search: { parent: "cm" },
  ConfirmOrder: { parent: "cm" },
  AddProductRequest: { parent: "cm" },
  ProductRequests: { parent: "cm" },
  CustomerSegmentList: { parent: "cm" },
  CustomerProfile: { parent: "cm" },
  NotServicable: { parent: "cm" },
  BankDetailsForm: { parent: "cm" },
  SupportTree: { parent: "cm" },
  SupportTickets: { parent: "cm" },
  SupportTicket: { parent: "cm" },
  CouponScreen: { parent: "cm" },
  LeaderTraining: { parent: "cm" },
  TrainingVideoListing: { parent: "cm" },
  SupportItem: { parent: "cm" },
  Passbook: { parent: "cm" },
  ReferEarnScreen: { parent: "cm" },
  InviteFriends: { parent: "cm" },
  ReferEarnStepsScreen: { parent: "cm" },
  ReferQRScreen: { parent: "cm" },
  ReferralList: { parent: "cm" },
  WithdrawMoney: { parent: "cm" },
  WithDrawGullakMoney: { parent: "cm" },
  GullakAddFund: { parent: "cm" },
  AddBankDetails: { parent: "cm" },
  WalletDynamicScreen: { parent: "cm" },
  TLAddress: { parent: "cm" },
  DeliveryPage: { parent: "cm" },
  WebView: { parent: "cm" },
  PollForm: { parent: "cm" },
  Error: { parent: "cm" },
  KYCSetup: { parent: "cm" },
  LeaderGrowthLadder: { parent: "cm" },
  ProfileInfo: { parent: "cm" },
  ProfileMain: { parent: "cm" },
  EditProfile: { parent: "cm" },
  EditBasicInfo: { parent: "cm" },
  ClContest: { parent: "cm" },
  PastContest: { parent: "cm" },
  ContestOverview: {
    parent: "cm",
    params: ["contest_id"],
  },
  OrderedList: {
    parent: "cm",
    params: ["contest_id", "orderedCx"],
  },
  MyCustomers: {
    parent: "cm",
    params: ["contest_id"],
  },
  DeliveryReturn: { parent: "cm" },
  MyTask: { parent: "cm" },
  PerformanceMetrics: { parent: "cm" },
  OTPVerification: { parent: "cm" },
  NewOTPVerification: { parent: "cm" },
  EarlyJourneyStack: { parent: "cm" },
  FullPageVideoModal: { parent: "cm" },
  OnBoardingQuestionaire: { parent: "cm" },
  EnterShopName: { parent: "cm" },
  EnterAddress: { parent: "cm" },
  LocationWithAddress: { parent: "cm" },
  MyDeliveries: {
    parent: "cm/main/home",
    params: ["order_ids"],
  },
  DeliveryOrdersList: {
    parent: "cm",
    params: [
      "order_ids",
      "spokeName",
      "date",
      "forNotDelivered",
      "type",
      "reasons",
    ],
  },
  DeliveryOrdersCrateList: {
    parent: "cm",
    params: [
      "order_ids",
      "spokeName",
      "date",
      "forNotDelivered",
      "type",
      "reasons",
    ],
  },
  SortingDeliveries: {
    parent: "cm",
    params: [
      "order_ids",
      "spokeName",
      "date",
      "forNotDelivered",
      "type",
      "reasons",
    ],
  },
  LoggedInDevices: { parent: "cm" },
  RatingInfo: { parent: "cm" },
  CustomerComplaint: { parent: "cm" },
  DBManagement: { parent: "cm" },
  OutForDelivery: { parent: "cm" },
};

const serialize = function (obj) {
  const str = [];

  for (const p in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(p)) {
      str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
    }
  }
  return `?${str.join("&")}`;
};

const sendEventByUtmContent = (deeplinkUrl) => {
  const parsedUrl = urlParse(deeplinkUrl, true);
  const { query, pathname } = parsedUrl;
  if (query.utm_content === "fpn") {
    analytics.trackEvent(NOTIFICATION_EVENTS.FPN_CLICKED, {
      ...query,
      app_screen: pathname.replace("/", ""),
    });
  }
};

const getProperLink = (url) => {
  let finalUrl = url;
  if (url && url.startsWith(LEGACY_BRANCH_PREFIX)) {
    // removing hash from the branch link
    const urlCopy = url;
    const l1 = urlCopy.replace(LEGACY_BRANCH_PREFIX, "");
    const l2 = l1.slice(l1.indexOf("/") + 1);
    finalUrl = LEGACY_BRANCH_PREFIX + l2;
  }

  sendEventByUtmContent(finalUrl);
  // parse legecy links old query params url to new nav params
  if (finalUrl && finalUrl.includes("app_screen")) {
    const parsedUrl = urlParse(finalUrl, true);
    const { query } = parsedUrl;
    let cpurl = LEGACY_BRANCH_PREFIX;
    if (query.app_screen) {
      cpurl += `${screen_config[query.app_screen].parent}/${query.app_screen}/`;
      if (screen_config[query.app_screen].params) {
        screen_config[query.app_screen].params.map((x) => {
          if (query[x]) {
            cpurl += `${query[x]}/`;
          }
        });
      }
      cpurl += serialize(query);
    }
    return cpurl;
  }
  if (url && url.startsWith(NATIVE_PREFIX)) {
    return url;
  }
  return finalUrl;
  // return null; ???
};

const handleLinking = async (url) => {
  if (!url) return;
  if (url.startsWith(NATIVE_PREFIX)) return url;
};

const linking = (userToken) => ({
  prefixes: [
    NATIVE_PREFIX,
    APPLINK_URI_SCHEME,
    APPLINK_PREFIX,
    LEGACY_BRANCH_PREFIX,
  ],

  // Custom function to get the URL which was used to open the app
  async getInitialURL() {
    let url = await Linking.getInitialURL();
    let validUrl;
    let isLongUrl = false;

    if (url?.startsWith(APPLINK_URI_SCHEME)) {
      url = url.replace(APPLINK_URI_SCHEME, "");
    }
    if (url?.includes("app_screen")) {
      validUrl = getProperLink(url);
      isLongUrl = true;
    }
    if (isLongUrl) {
      if (userToken && validUrl) {
        return validUrl;
      } else if (!userToken) {
        store.dispatch(setDeepLinkParams({ url: validUrl }));
      }
    } else return handleLinking(url);
  },

  // Custom function to subscribe to incoming links
  subscribe(listener) {
    const onReceiveURL = ({ url: dirtyUrl }) => {
      let url = dirtyUrl;
      if (url?.startsWith(APPLINK_URI_SCHEME)) {
        url = url.replace(APPLINK_URI_SCHEME, "");
      }
      if (
        url?.startsWith(APPLINK_PREFIX) ||
        url?.startsWith(LEGACY_BRANCH_PREFIX)
      ) {
        store.dispatch({ type: "SET_APPLINK", payload: url });
      }
      if (userToken) {
        if (url) {
          const URL = getProperLink(url);
          if (URL) {
            listener(URL);
          }
        }
      } else {
        if (url) {
          store.dispatch(setDeepLinkParams({ url }));
        }
      }
    };

    const urlListener = Linking.addEventListener("url", onReceiveURL);

    return () => {
      urlListener?.remove();
    };
  },

  config: {
    screens: {
      HomeStack: {
        path: "cm",
        initialRouteName: "Bottoms",
        screens: {
          DailyGreetings: {
            path: "DailyGreetings/:entityId/",
            parse: {
              entityId: (entityId) => entityId,
            },
          },

          DynamicCMSListing: {
            path: "DynamicCMSListing/:entityId/",
            parse: {
              entityId: (entityId) => entityId,
            },
          },

          ProductDetails: {
            path: "ProductDetails/:slug",
            parse: {
              slug: (slug) => slug,
            },
          },

          OrderDetails: {
            path: "OrderDetails/:order_id",
            parse: {
              order_id: (order_id) => order_id,
            },
          },

          CategoryNavigationScreen: {
            path: "CategoryNavigationScreen/:selectedCat/:selectedSubCat",
            parse: {
              selectedCat: (selectedCat) => selectedCat,
              selectedSubCat: (selectedSubCat) => selectedSubCat,
            },
          },

          Bottoms: {
            path: "main",
            screens: {
              home: {
                path: "home",
                screens: {
                  // Optional: a required param serialises a param-less Home as
                  // "Home/undefined", and on a web reload LoginInfo then
                  // JSON.parses the string "undefined" and blanks the app.
                  Home: {
                    path: "Home/:pnData?",
                    parse: {
                      pnData: (pnData) =>
                        pnData && pnData !== "undefined"
                          ? decodeURIComponent(pnData)
                          : undefined,
                    },
                  },
                  Training: {
                    path: "Training",
                  },
                  Orders: {
                    path: "Orders",
                  },
                  Customers: {
                    path: "Customers",
                  },
                  Gullak: {
                    path: "Gullak",
                  },
                  MyDeliveries: {
                    path: "MyDeliveries/:order_ids?",
                    parse: {
                      order_ids: (entityId) => entityId,
                    },
                    screens: {
                      today: "today",
                      upcoming: "upcoming",
                      past: "past",
                    },
                  },
                  NotFound: "*",
                },
              },
            },
          },
          LanguageSelection: "LanguageSelection",
          Vacation: "Vacation",
          VacationCalendar: "VacationCalendar",
          VacationTnC: "VacationTnC",
          VacationOrdersList: "VacationOrdersList",
          RateOrder: "RateOrder",
          Customer: "Customer",
          AddCustomer: "AddCustomer",
          Search: "Search",
          ConfirmOrder: "ConfirmOrder",
          AddProductRequest: "AddProductRequest",
          ProductRequests: "ProductRequests",
          CustomerSegmentList: "CustomerSegmentList",
          CustomerProfile: "CustomerProfile",
          UsersOrderList: "UsersOrderList",
          DeliveryOrderList: "DeliveryOrderList",
          NotServicable: "NotServicable",
          BankDetailsForm: "BankDetailsForm",
          SupportTree: "SupportTree",
          SupportTickets: "SupportTickets",
          SupportTicket: "SupportTicket",
          CouponScreen: "CouponScreen",
          LeaderTraining: "LeaderTraining",
          TrainingVideoListing: "TrainingVideoListing",
          SupportItem: "SupportItem",
          Passbook: "Passbook",
          ReferEarnScreen: "ReferEarnScreen",
          InviteFriends: "InviteFriends",
          ReferEarnStepsScreen: "ReferEarnStepsScreen",
          ReferQRScreen: "ReferQRScreen",
          ReferralList: "ReferralList",
          WithdrawMoney: "WithdrawMoney",
          WithDrawGullakMoney: "WithDrawGullakMoney",
          GullakAddFund: "GullakAddFund",
          WithdrawFromAcc: "WithdrawFromAcc",
          FindUpi: "FindUpi",
          AddBankDetails: "AddBankDetails",
          WalletDynamicScreen: "WalletDynamicScreen",
          TLAddress: "TLAddress",
          DeliveryPage: "DeliveryPage",
          WebView: "WebView",
          PollForm: "PollForm",
          KYCSetup: "KYCSetup",
          LeaderGrowthLadder: "LeaderGrowthLadder",
          ProfileInfo: {
            path: "pf",
            screens: {
              ProfileMain: "ProfileMain",
              EditProfile: "EditProfile",
              TLAddress: "TLAddress",
              EditBasicInfo: "EditBasicInfo",
            },
          },
          ProfileMain: "ProfileMain",
          EditProfile: "EditProfile",
          EditBasicInfo: "EditBasicInfo",
          NotFound: "*",
          ClContest: "ClContest",
          PastContest: "PastContest",
          ContestOverview: {
            path: "ContestOverview/:contest_id",
            parse: {
              contest_id: (contest_id) => contest_id,
            },
          },
          OrderedList: {
            path: "OrderedList/:contest_id/:orderedCx",
            parse: {
              contest_id: (contest_id) => contest_id,
              orderedCx: (orderedCx) => orderedCx,
            },
          },
          MyCustomers: {
            path: "MyCustomers/:contest_id",
            parse: {
              contest_id: (contest_id) => contest_id,
            },
          },
          DeliveryReturn: "DeliveryReturn",
          MyTask: "MyTask",
          PerformanceMetrics: "PerformanceMetrics",
          OTPVerification: "OTPVerification",
          DeliveryOrdersList: {
            path: "DeliveryOrdersList/:order_ids/:spokeName/:date/:forNotDelivered/:type/:reasons/",
            parse: {
              order_ids: (order_ids) => order_ids,
              spokeName: (spokeName) => spokeName,
              date: (date) => date,
              forNotDelivered: (forNotDelivered) => forNotDelivered,
              type: (type) => type,
              reasons: (reasons) => reasons,
            },
          },
          DeliveryOrdersCrateList: {
            path: "DeliveryOrdersCrateList/:order_ids/:spokeName/:date/:forNotDelivered/:type/:reasons/",
            parse: {
              order_ids: (order_ids) => order_ids,
              spokeName: (spokeName) => spokeName,
              date: (date) => date,
              forNotDelivered: (forNotDelivered) => forNotDelivered,
              type: (type) => type,
              reasons: (reasons) => reasons,
            },
          },
          SortingDeliveries: {
            path: "SortingDeliveries/:order_ids/:spokeName/:date/:forNotDelivered/:type/:reasons/",
            parse: {
              order_ids: (order_ids) => order_ids,
              spokeName: (spokeName) => spokeName,
              date: (date) => date,
              forNotDelivered: (forNotDelivered) => forNotDelivered,
              type: (type) => type,
              reasons: (reasons) => reasons,
            },
          },
          LoggedInDevices: "LoggedInDevices",
          RatingInfo: "RatingInfo",
          CustomerComplaint: "CustomerComplaint",
        },
      },
      NotFound: "*",
    },
  },
});
const onNavigationContainerReady = () => {
  // eslint-disable-next-line import/no-named-as-default-member
  BootSplash.hide({ fade: true });
  routingInstrumentation.registerNavigationContainer(navigationRef);
};

/* selectors */
const userTokenSelector = (s) => s.auth?.userToken;

function AppNavigation() {
  // eslint-disable-next-line no-shadow
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const userHaveEarlyJourney = useSelector(
    (state) => state.auth.user.earlyJourney,
  );
  const userToken = useSelector(userTokenSelector);
  // const { getInitialState } = useLinking(navigationRef, linking(userToken));
  // const [isReady, setIsReady] = React.useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, import/no-named-as-default-member
  const [initialState, setInitialState] = React.useState();

  // React.useEffect(() => {
  //   Promise.race([getInitialState()])
  //     .catch((e) => {
  //       console.error(e);
  //     })
  //     .then((state) => {
  //       if (state !== undefined) {
  //         setInitialState(state);
  //         updateCurrentAppScreen(state);
  //       }
  //       setIsReady(true);
  //     });
  // }, [getInitialState]);

  const {
    already_a_cx,
    already_a_cx_wo_order,
    discarded_at,
    rejected_at,
    device_location_geog,
    lat,
    lng,
    leader_state,
    name: userName,
    pincode: userPincode,
    is_serviceable: user_is_serviceable,
    // earlyJourney: userHaveEarlyJourney,
  } = user;

  // if (!isReady) {
  //   return null;
  // }

  return (
    <NavigationContainer
      initialState={initialState}
      linking={linking(userToken)}
      onReady={onNavigationContainerReady}
      fallback={<AuthLoadingScreen />}
      ref={navigationRef}
      onStateChange={(state) => {
        const currentRouteName = getActiveRouteName(state);
        routeNameRef.current = currentRouteName;
        dispatch(navActions.setCurrentRouteName(currentRouteName));
        const currentRoute = navigationRef.current.getCurrentRoute().name;
        routeNameRef.current = currentRoute;
        previousScreens.current = Array.isArray(previousScreens.current)
          ? previousScreens.current.concat(currentRoute)
          : [currentRoute];
      }}
    >
      <Stack.Navigator screenOptions={commonHeaderConfig}>
        {!userToken ? (
          <Stack.Screen name="AuthStack" component={AuthStackScreen} />
        ) : discarded_at ||
          rejected_at ||
          leader_state === "LEADER_DISCARDED" ? (
          <Stack.Screen
            name="DiscardedStackScreen"
            component={DiscardedStackScreen}
          />
        ) : leader_state === "LEADER_DEACTIVATED" ? (
          <Stack.Screen
            name="DeactivatedStackScreen"
            component={DeactivatedStackScreen}
          />
        ) : !userName ? (
          <Stack.Screen name="EnterNameStack" component={NameStackScreen} />
        ) : already_a_cx || already_a_cx_wo_order ? (
          <Stack.Screen
            name="PrivilegeStackScreen"
            component={PrivilegeStackScreen}
          />
        ) : !(userPincode && device_location_geog && lat && lng) ? (
          <Stack.Screen name="LocationStack" component={LocationStack} />
        ) : user_is_serviceable === false ? (
          <Stack.Screen name="NoServiceStack" component={NoServiceStack} />
        ) : userHaveEarlyJourney?.enableIJ ? (
          <Stack.Screen name="CLFlow" component={CLFlow} />
        ) : userHaveEarlyJourney?.enableEJ ? (
          <Stack.Screen
            name="EarlyJourneyStack"
            component={EarlyJourneyStack}
          />
        ) : (
          <Stack.Screen name="HomeStack" component={HomeScreenStack} />
        )}
      </Stack.Navigator>
    </NavigationContainer>
  );
}

export default AppNavigation;
